import { render, staticRenderFns } from "./FormInputMultiLineText.vue?vue&type=template&id=0c24b3c7&scoped=true&"
import script from "./FormInputMultiLineText.vue?vue&type=script&lang=ts&"
export * from "./FormInputMultiLineText.vue?vue&type=script&lang=ts&"
import style0 from "./FormInputMultiLineText.vue?vue&type=style&index=0&id=0c24b3c7&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c24b3c7",
  null
  
)

export default component.exports